module.exports = __webpack_public_path__ + "components/patterns/homepageSplashImage/rct-logo-white.png";